import { render, staticRenderFns } from "./TableLivePlayers.vue?vue&type=template&id=338a504f&scoped=true"
import script from "./TableLivePlayers.js?vue&type=script&lang=js&external"
export * from "./TableLivePlayers.js?vue&type=script&lang=js&external"
import style0 from "./TableLivePlayers.vue?vue&type=style&index=0&id=338a504f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338a504f",
  null
  
)

export default component.exports